import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { InboxCounts } from 'data/api/conversation.api';
import { RootState } from './store';

// Shared between the sidebar badge and the inbox page so a claim/escalate
// on the page updates the badge without its own polling.
export interface InboxState {
  counts: InboxCounts | null;
  // Monotonic guard: sidebar and page fetches overlap, and a slow, older
  // response must not overwrite a fresher snapshot.
  countsRequestedAt: number;
}

const initialState: InboxState = {
  counts: null,
  countsRequestedAt: 0,
};

export const inboxSlice = createSlice({
  name: 'inbox',
  initialState,
  reducers: {
    saveInboxCounts: (
      state,
      action: PayloadAction<{ counts: InboxCounts; requestedAt: number }>,
    ) => {
      if (action.payload.requestedAt >= state.countsRequestedAt) {
        state.counts = action.payload.counts;
        state.countsRequestedAt = action.payload.requestedAt;
      }
    },
  },
});

export const { saveInboxCounts } = inboxSlice.actions;
export const selectInboxCounts = (state: RootState) => state.inbox.counts;
export default inboxSlice.reducer;
